import React, { useEffect } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import BottomNav    from './components/BottomNav';
import Notification from './components/Notification';
import MainPage     from './pages/MainPage';
import CartPage     from './pages/CartPage';
import ConfigPage   from './pages/ConfigPage';
import StatsPage    from './pages/StatsPage';
import './index.css';

function Pages() {
  const { page, setPage, loading } = useApp();

  useEffect(() => {
    // Al cambiar de página, agrega una entrada al historial
    if (page !== 'main') {
      window.history.pushState({ page }, '');
    }
  }, [page]);

  useEffect(() => {
    // Cuando el usuario aprieta "Atrás", vuelve a main
    const handleBack = (e) => {
      e.preventDefault();
      setPage('main');
    };
    window.addEventListener('popstate', handleBack);
    return () => window.removeEventListener('popstate', handleBack);
  }, [setPage]);

  if (loading) {
    return (
      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', gap:16 }}>
        <div style={{ width:40, height:40, border:'3px solid rgba(232,67,90,.2)', borderTopColor:'var(--acc)', borderRadius:'50%', animation:'spin .8s linear infinite' }}/>
        <p style={{ color:'var(--t1)', fontSize:14 }}>Cargando inventario...</p>
      </div>
    );
  }

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%', overflow:'hidden' }}>
      <div style={{ flex:1, overflow:'hidden', minHeight:0 }}>
        {page === 'main'  && <MainPage/>}
        {page === 'cart'  && <CartPage/>}
        {page === 'cfg'   && <ConfigPage/>}
        {page === 'stats' && <StatsPage/>}
      </div>
      <BottomNav/>
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Notification/>
      <Pages/>
    </AppProvider>
  );
}
